import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import cn from 'classnames';

import logEvent from 'analytics/logEvent';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';

import pageUrls from 'constants/pagesUrls';

import ALink from 'components/basic/ALink';
import AuthFormWrapper from 'components/basic/AuthFormWrapper';
import { H1, H3 } from 'components/basic/Typography';
import AuthForm from 'components/complex/forms/AuthForm';
import Page from 'components/layouts/Page';

import { getSafeRedirect } from 'utils/getSafeRedirect';

import styles from './LoginPage.module.scss';

export default function LoginPageComponent(): JSX.Element {
  const router = useRouter();
  const t = useTranslationAndTypograph();
  let nextUrl = '';

  if (typeof router.query.next === 'string') {
    const safeNext = getSafeRedirect(router.query.next);
    nextUrl = `?next=${safeNext}`;
  }

  let redirectUrl: string = '';
  if (typeof router.query.destination === 'string') {
    const safeDestination = getSafeRedirect(router.query.destination);
    redirectUrl = safeDestination;
  }

  if (redirectUrl) {
    nextUrl = `${nextUrl ? '&' : '?'}destination=${encodeURIComponent(redirectUrl) as string}`;
  }

  useEffect(() => {
    logEvent('Web_Sign-in_Page_Viewed', {
      search: window.location.search || null
    });
  }, []);

  return (
    <Page fullHeight removeBottomPadding={true}>
      <div className={styles.authWrapper}>
        <>
          <div className={styles.bg}>
            <Image
              src="/pagesImages/auth-reg/auth-bg.png"
              width={800}
              height={704}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <div className={styles.bgMobile}>
            <Image
              src="/pagesImages/auth-reg/auth-bg_mobile.png"
              width={375}
              height={812}
              layout="fill"
              objectFit="cover"
            />
          </div>
        </>
        <div className={styles.authHeaderWrapper}>
          <H1 className={cn(styles.authTitle, "cy-login-title")}>{t('Log into your account')}</H1>
          <H3 className={styles.authSubTitle}>
            {t('If you dont have account')}{' '}
            <ALink href={`${pageUrls.registration}${nextUrl}`}>
              {t('create a new account')}
            </ALink>
          </H3>
        </div>
        <div className={styles.authContentWrapper}>
          <AuthFormWrapper withoutTopPadding={true}>
            <AuthForm redirectUrl={redirectUrl as string} />
          </AuthFormWrapper>
        </div>
      </div>
    </Page>
  );
}
